/** Base URL without trailing slash. Empty = same-origin (Vite dev proxy → backend). */
function apiBase(): string {
  const raw = import.meta.env.VITE_API_BASE_URL;
  if (typeof raw === 'string' && raw.length > 0) return raw.replace(/\/$/, '');
  return '';
}

export type ValidateUniqueCodeResult =
  | { valid: true; codeUsed: boolean; codeBrand: string | null }
  | { valid: false; message?: string };

/**
 * Checks `code` against `UniqueCode.code` in the database (case-insensitive).
 * When `valid: true`, includes `codeUsed` and `codeBrand` from the row.
 */
export async function validateUniqueCode(code: string): Promise<ValidateUniqueCodeResult> {
  const res = await fetch(`${apiBase()}/api/v1/unique-codes/validate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });

  const data = (await res.json()) as {
    valid?: boolean;
    codeUsed?: boolean;
    codeBrand?: string | null;
    message?: string;
  };

  if (!res.ok) {
    return {
      valid: false,
      message: data.message ?? 'Unable to verify unique code. Please try again.',
    };
  }

  if (data.valid === true && typeof data.codeUsed === 'boolean') {
    return {
      valid: true,
      codeUsed: data.codeUsed,
      codeBrand: typeof data.codeBrand === 'string' ? data.codeBrand : data.codeBrand ?? null,
    };
  }

  return {
    valid: false,
    message: data.message ?? 'Unique code not found',
  };
}
